const toggle = $("[data-faq=toggle]")

toggle.click((e) => {
  const item = $(e.currentTarget).parent()

  item.toggleClass("active")
})



// WEBPACK FOOTER //
// ./src/blocks/faq/faq.js